import copy from 'copy-to-clipboard';

function copyToClipboard(str: string): boolean {
  return copy(str);
}

export default copyToClipboard;
